@if (readonly === false) {
    @switch (attributeDefinition.type) {
        @case (PropertyType.Long) {
            <!-- Affichage d'un attribut de type 'Entier' en édition -->
            <div class="form-item" [ngClass]="{ error: isRequiredError || isInvalidError, readonly: readonly }">
                <mat-form-field>
                    <mat-label>{{ attributeDefinition.header }}</mat-label>
                    <input
                        matInput
                        [readonly]="readonly"
                        data-input-name
                        type="text"
                        autocomplete="off"
                        [formControl]="attributeFormControl"
                        (keyup.enter)="onAttributeInputChange($event.target.value)"
                        (focusout)="onAttributeInputChange($event.target.value)"
                        [ngClass]="{ error: isRequiredError || isInvalidError }"
                        [errorStateMatcher]="errorStateMatcher"
                        (contextmenu)="$event.preventDefault(); openMenu($event)"
                        (paste)="onPaste($event)" />
                    @if (attributeFormControl.hasError('required')) {
                        <mat-error>Le champ est obligatoire</mat-error>
                    }
                    @if (attributeFormControl.hasError('invalidError')) {
                        <mat-error>
                            <span title="La valeur n'est pas un nombre entier valide.">La valeur n'est pas un nombre entier valide.</span>
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        }
        @case (PropertyType.Decimal) {
            <!-- Affichage d'un attribut de type 'Décimal' en édition -->
            <div class="form-item" [ngClass]="{ error: isRequiredError || isInvalidError, readonly: readonly }">
                <mat-form-field>
                    <mat-label>{{ attributeDefinition.header }}</mat-label>
                    <input
                        matInput
                        [readonly]="readonly"
                        data-input-name
                        type="text"
                        autocomplete="off"
                        [formControl]="attributeFormControl"
                        (keyup.enter)="onAttributeInputChange($event.target.value)"
                        (focusout)="onAttributeInputChange($event.target.value)"
                        [ngClass]="{ error: isRequiredError || isInvalidError }"
                        [errorStateMatcher]="errorStateMatcher"
                        (contextmenu)="$event.preventDefault(); openMenu($event)"
                        (paste)="onPaste($event)" />
                    @if (attributeFormControl.hasError('required')) {
                        <mat-error>Le champ est obligatoire</mat-error>
                    }
                    @if (attributeFormControl.hasError('invalidError')) {
                        <mat-error>
                            <span title="La valeur n'est pas un nombre décimal valide.">La valeur n'est pas un nombre décimal valide.</span>
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        }
        @case (PropertyType.Color) {
            <!-- Affichage d'un attribut de type 'Couleur' en édition -->
            <div class="form-item color-attribute" [ngClass]="{ error: isRequiredError || isInvalidError, readonly: readonly }">
                <mat-form-field>
                    <mat-label>{{ attributeDefinition.header }}</mat-label>
                    <mat-select
                        #matSelectAttribute
                        [placeholder]="attributeDefinition.mandatory === true ? attributeDefinition.header + '*' : attributeDefinition.header"
                        panelClass="select-color-panel"
                        [formControl]="attributeFormControl"
                        (selectionChange)="onAttributeInputChange($event.value)"
                        [value]="selectedColor"
                        [ngClass]="{ error: isRequiredError, readonly: readonly }"
                        (contextmenu)="$event.preventDefault(); openMenu($event)">
                        @if (selectedColor) {
                            <mat-select-trigger>
                                <div class="color-indicator" ngClass="bak-{{ selectedColor }}-color"></div>
                            </mat-select-trigger>
                        }
                        <mat-option [value]="Colors.None">Aucune</mat-option>
                        <mat-option [value]="Colors.Green">
                            <div class="color-indicator mat-option-green-color"></div>
                        </mat-option>
                        <mat-option [value]="Colors.Orange">
                            <div class="color-indicator mat-option-orange-color"></div>
                        </mat-option>
                        <mat-option [value]="Colors.Red">
                            <div class="color-indicator mat-option-red-color"></div>
                        </mat-option>
                        <mat-option [value]="Colors.Grey">
                            <div class="color-indicator mat-option-grey-color"></div>
                        </mat-option>
                        <mat-option [value]="Colors.LightBlue">
                            <div class="color-indicator mat-option-light-blue-color"></div>
                        </mat-option>
                        <mat-option [value]="Colors.DarkBlue">
                            <div class="color-indicator mat-option-dark-blue-color"></div>
                        </mat-option>
                    </mat-select>
                    @if (isRequiredError) {
                        <mat-error>Le champ est obligatoire</mat-error>
                    }
                    @if (isInvalidError) {
                        <mat-error>
                            <span title="{{ invalidMessage }}">{{ invalidMessage }}</span>
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        }
        @case (PropertyType.DateAndTime) {
            <!-- Affichage d'un attribut de type 'Date & heure' en édition -->
            <div class="form-item" [ngClass]="{ error: isRequiredError || isInvalidError, readonly: readonly }">
                <mat-form-field>
                    <mat-label>{{ attributeDefinition.header }}</mat-label>
                    <input
                        matInput
                        [ngxMatDatetimePicker]="picker"
                        [formControl]="attributeFormControl"
                        (dateChange)="onAttributeDateChange($event)"
                        (focusout)="onAttributeInputChange($event.target.value)"
                        autocomplete="off"
                        (contextmenu)="$event.preventDefault(); openMenu($event)"
                        (paste)="onPaste($event)" />
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <ngx-mat-datetime-picker #picker (opened)="onOpen()" (closed)="onClose()"></ngx-mat-datetime-picker>
                    @if (isRequiredError) {
                        <mat-error>Le champ est obligatoire</mat-error>
                    }
                    @if (isInvalidError) {
                        <mat-error>
                            <span title="{{ invalidMessage }}">{{ invalidMessage }}</span>
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        }
        @case (PropertyType.Date) {
            <!-- Affichage d'un attribut de type 'Date' en édition -->
            <div class="form-item" [ngClass]="{ error: isRequiredError || isInvalidError, readonly: readonly }">
                <mat-form-field>
                    <mat-label>{{ attributeDefinition.header }}</mat-label>
                    <input
                        matInput
                        [matDatepicker]="datepicker"
                        [formControl]="attributeFormControl"
                        (dateChange)="onAttributeDateChange($event)"
                        autocomplete="off"
                        (contextmenu)="$event.preventDefault(); openMenu($event)"
                        (paste)="onPaste($event)" />
                    <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                    <mat-datepicker #datepicker></mat-datepicker>
                    @if (isRequiredError) {
                        <mat-error>Le champ est obligatoire</mat-error>
                    }
                    @if (isInvalidError) {
                        <mat-error>
                            <span title="{{ invalidMessage }}">{{ invalidMessage }}</span>
                        </mat-error>
                    }
                </mat-form-field>
            </div>
        }
        @case (PropertyType.Link) {
            <!-- Affichage d'un attribut de type 'Lien' en édition-->
            <div class="link-attribute">
                <mat-label>{{ attributeDefinition.mandatory === true ? attributeDefinition.header + '*' : attributeDefinition.header }}</mat-label>
                <div class="link-attribute-value">
                    @if (value) {
                        <a href="{{ value | avmLink: 'Url' : true }}" target="_blank">{{ value | avmLink: 'DisplayName' : true }}</a>
                    }
                    @if (!value) {
                        <span>{{ value | avmLink: 'DisplayName' : true }}</span>
                    }
                    <button mat-icon-button class="accent-button small edit-button" (click)="onEditLink(value)"><fa-icon [icon]="faLink"></fa-icon></button>
                    @if (value) {
                        <button mat-icon-button class="accent-button small" (click)="onDeleteLink()"><fa-icon [icon]="faxmark"></fa-icon></button>
                    }
                </div>
            </div>
        }
        @case (PropertyType.AutocompletionByApi) {
            <!-- Affichage d'un attribut de type 'autocompletion par API' en édition -->
            <div class="form-item" [ngClass]="{ error: isRequiredError || isInvalidError, readonly: readonly }">
                <mat-form-field>
                    <mat-label>{{ attributeDefinition.header }}</mat-label>
                    <input
                        matInput
                        [readonly]="readonly"
                        data-input-name
                        type="text"
                        [formControl]="attributeFormControl"
                        [errorStateMatcher]="errorStateMatcher"
                        (contextmenu)="$event.preventDefault(); openMenu($event)"
                        [matAutocomplete]="auto" />
                    <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (closed)="onAutocompleteClosed()" (optionSelected)="onAutocompleteItemSelected($event)">
                        <mat-option *ngFor="let autocompletionValue of autocompletionValues | async" [value]="autocompletionValue">{{ autocompletionValue }}</mat-option>
                    </mat-autocomplete>
                    @if (attributeFormControl.hasError('required')) {
                        <mat-error>Le champ est obligatoire</mat-error>
                    }
                </mat-form-field>
            </div>
        }
        @default {
            @if (attributeDefinition.type == PropertyType.Text || attributeDefinition.type == PropertyType.Email || attributeDefinition.type == PropertyType.PhoneNumber) {
                <!-- Affichage d'un attribut de type 'Texte', 'Email' ou 'N° de téléphone' en édition -->
                <div class="form-item" [ngClass]="{ error: isRequiredError || isInvalidError, readonly: readonly }">
                    <mat-form-field>
                        <mat-label>{{ attributeDefinition.header }}</mat-label>
                        <input
                            matInput
                            [readonly]="readonly"
                            data-input-name
                            type="text"
                            autocomplete="off"
                            [formControl]="attributeFormControl"
                            (keyup.enter)="onAttributeInputChange($event.target.value)"
                            (focusout)="onAttributeInputChange($event.target.value)"
                            [errorStateMatcher]="errorStateMatcher"
                            (contextmenu)="$event.preventDefault(); openMenu($event)"
                            (paste)="onPaste($event)" />
                        @if (attributeFormControl.hasError('required')) {
                            <mat-error>Le champ est obligatoire</mat-error>
                        }
                        @if (attributeFormControl.hasError('pattern')) {
                            <mat-error>
                                <span title="Le champ doit respecter l'expression régulière : {{ attributeDefinition.format }}.">
                                    Le champ doit respecter l'expression régulière : {{ attributeDefinition.format }}.
                                </span>
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
            } @else if (
                attributeDefinition.type == PropertyType.List || attributeDefinition.type == PropertyType.ListCustomers || attributeDefinition.type == PropertyType.ListUsers
            ) {
                <!-- Affichage d'un attribut de type 'Liste' en édition -->
                <div class="form-item" [ngClass]="{ error: isRequiredError || isInvalidError, readonly: readonly }">
                    <mat-form-field>
                        <mat-label>{{ attributeDefinition.header }}</mat-label>
                        <mat-select
                            #matSelectAttribute
                            [formControl]="attributeFormControl"
                            [value]="selectedListItemKey"
                            (selectionChange)="onAttributeInputChange($event.value)"
                            (focusout)="onAttributeInputChange(matSelectAttribute.value)"
                            [ngClass]="{ error: isRequiredError, readonly: readonly }"
                            (contextmenu)="$event.preventDefault(); openMenu($event)">
                            @for (item of listItems; track item.value) {
                                <mat-option [value]="item.value">{{ item.text }}</mat-option>
                            }
                        </mat-select>
                        @if (isRequiredError) {
                            <mat-error>Le champ est obligatoire</mat-error>
                        }
                        @if (isInvalidError) {
                            <mat-error>
                                <span title="{{ invalidMessage }}">{{ invalidMessage }}</span>
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
            }
        }
    }
}

@if (readonly === true) {
    <div class="read-only-attribute">
        <mat-label class="attribute-label">{{ attributeDefinition.header }}</mat-label>
        @switch (attributeDefinition.type) {
            @case (PropertyType.Text) {
                <!-- Affichage d'un attribut de type 'Texte' en consultation -->
                <span [title]="value">{{ value | avmFormNullableValue: readonly }}</span>
            }
            @case (PropertyType.Email) {
                <!-- Affichage d'un attribut de type 'Email' en consultation -->
                <span [title]="value">{{ value | avmFormNullableValue: readonly }}</span>
            }
            @case (PropertyType.PhoneNumber) {
                <!-- Affichage d'un attribut de type 'N° de téléphone' en consultation -->
                <span [title]="value">{{ value | avmFormNullableValue: readonly : attributeDefinition.displayFormat }}</span>
            }
            @case (PropertyType.Long) {
                <!-- Affichage d'un attribut de type 'Entier' en consultation -->
                <span [title]="value">{{ value | avmFormNullableValue: readonly }}</span>
            }
            @case (PropertyType.Decimal) {
                <!-- Affichage d'un attribut de type 'Décimal' en consultation -->
                <span [title]="value">{{ value | avmFormNullableValue: readonly }}</span>
            }
            @case (PropertyType.Color) {
                <!-- Affichage d'un attribut de type 'Couleur' en consultation -->
                <div class="color-indicator" ngClass="bak-{{ value }}-color"></div>
            }
            @case (PropertyType.Date) {
                <!-- Affichage d'un attribut de type 'Date' en consultation -->
                <span>
                    {{ dateValue | avmFormNullableDateValue: attributeDefinition.displayFormat }}
                </span>
            }
            @case (PropertyType.DateAndTime) {
                <!-- Affichage d'un attribut de type 'Date & heure' en consultation -->
                <span>
                    {{ dateValue | avmFormNullableDateValue: attributeDefinition.displayFormat }}
                </span>
            }
            @case (PropertyType.Link) {
                <!-- Affichage d'un attribut de type 'Lien' en consultation -->
                <div class="link-attribute-value">
                    @if (enumHelper.areEquals(PropertyType, attributeDefinition.type, PropertyType.Link)) {
                        <div class="link-attribute-value">
                            <a href="{{ value | avmLink: 'Url' : false }}" target="_blank">{{ value | avmLink: 'DisplayName' : false }}</a>
                        </div>
                    }
                </div>
            }
            @case (PropertyType.List) {
                <!-- Affichage d'un attribut de type 'Liste' en consultation -->
                <span>
                    {{ value | avmFormNullableListValue: listItems }}
                </span>
            }
            @case (PropertyType.ListUsers) {
                <!-- Affichage d'un attribut de type 'Liste d'utilisateurs' en consultation -->
                <span>
                    {{ value | avmFormNullableListValue: listItems }}
                </span>
            }
            @case (PropertyType.ListCustomers) {
                <!-- Affichage d'un attribut de type 'Liste de clients' en consultation -->
                <span>
                    {{ value | avmFormNullableListValue: listItems }}
                </span>
            }
            @case (PropertyType.AutocompletionByApi) {
                <!-- Affichage d'un attribut de type 'autocompletion par API' en consultation -->
                <span [title]="value">{{ value | avmFormNullableValue: readonly }}</span>
            }
        }
    </div>
}
<div style="visibility: hidden; position: fixed" [style.left]="contextMenuPosition.x" [style.top]="contextMenuPosition.y" [matMenuTriggerFor]="contextMenu"></div>
<mat-menu class="avmup-menu" #contextMenu="matMenu">
    <a class="avmup-menu-item mat-mdc-menu-item" (click)="onContextMenuClick($event, 'erase')">
        <fa-icon [icon]="faEraser"></fa-icon>
        <span>Vider la valeur</span>
    </a>
</mat-menu>
